<template>
  <div>
    <SelectFullScreen v-if="displaySelectFull" :title="name" :type_list="type_list" :search="search" :data="formatData"
      :defaultSelected="filters" :hideValue="hide_value" @data-selected="filters = $event" @validate="storeData()"
      @close="displaySelectFull = false" />
    <div style="text-align: left" class="full-screen bordered-bottom">
      <label class="label" @click="displaySelectFull = true">{{ label }}</label>
      <div class="main-form">
        <div class="segments" @click="displaySelectFull = true">
          <div v-for="(segment, index) in filters" :key="index" class="segment">
            <div v-if="type_list === 'multiple' || (type_list === 'simple' && index === 0)">
              <span v-if="segment.label">{{
      $te(`form.${segment.label}`) ? $t(`form.${segment.label}`) : segment.label
    }}</span>
              <span v-else>{{ getDisplaySegment(segment.value) }}</span>
              <span v-if="index != Object.keys(filters).length - 1 && type_list === 'multiple'">
                <span style="font-weight: bold">&#8239;/&#8239;</span>
              </span>
            </div>
          </div>
        </div>
        <div v-if="filters.length > 0 && showCross" class="delete-values" @click="[(filters = []), storeData()]">
          <img src="@/assets/icons/close.png" alt="clean field">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectFullScreen from '@/components/GenericComponents/Form/SelectFullScreen.vue'
import { configurationService } from '@/services/configuration.service'
import { mapState } from 'pinia'
import { appConfigurationStore } from '@/stores/appConfigurationStore.js'
import countriesGB from '@/data/countries-en-GB.json'
import countriesJson from '@/mixins/CombinedCountries.js'

export default {
  name: 'FormFullScreen',
  components: {
    SelectFullScreen
  },
  props: {
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type_list: {
      type: String,
      default: ''
    },
    search: {
      type: Boolean,
      default: false
    },
    selectValues: {
      type: [Object, Array],
      default: null
    },
    defaultValue: {
      type: [Object, Array],
      default: null
    },
    apiUrl: {
      type: String,
      default: null
    },
    hide_value: {
      type: Boolean,
      default: false
    },
    showCross: {
      type: Boolean,
      default: true
    }
  },
  emits: ['addData'],
  data() {
    return {
      displaySelectFull: false,
      filters: [],
      apiSelectValues: null,
      countries: countriesGB,
      permissions: this.$seller.currentSeller ? this.$seller.currentSeller.permissions : []
    }
  },
  computed: {
    ...mapState(appConfigurationStore, ['appConfiguration']),
    formatData() {
      let array = []
      switch (this.name) {
        case 'country':
        case 'nationality':
        case 'time-slot-picker':
          for (const iterator of this.countries) {
            array.push(this.formatDataSelectFullScreen(iterator.name, iterator.code, { typelist: this.type_list }))
          }
          return array
        case 'phone_prefix':
          for (const iterator of this.countries) {
            array.push(
              this.formatDataSelectFullScreen(iterator.name, iterator.code, {
                code: iterator.code,
                typelist: this.type_list
              })
            )
          }
          return array
        case 'customer_segment':
        case 'salesRevenueSelect':
          for (const iterator of this.apiSelectValues) {
            array.push(this.formatDataSelectFullScreen(iterator.label, iterator.id, { typelist: 'multiple' }))
          }
          return array
        default:
          for (const element of this.selectValues) {
            if (this.name == element.name) {
              switch (element.name) {
                case 'seller':
                  for (const iterator of element.data) {
                    array.push(
                      this.formatDataSelectFullScreen(
                        iterator.firstname_user + ' ' + iterator.name_user,
                        iterator.id_user
                      )
                    )
                  }
                  break
                case 'store':
                  for (const iterator of element.data) {
                    array.push(
                      this.formatDataSelectFullScreen(iterator.name_store, iterator.id_store, {
                        external_id: iterator.external_id
                      })
                    )
                  }
                  break
              }
            }
          }
          return array
      }
    }
  },
  watch: {
    selectValues() {
      if (this.name === 'seller') {
        this.filters = []
      }
    },
    '$i18n.locale'() {
      this.setCountryJson(this.$i18n.locale)
    }
  },
  async created() {
    if (this.apiUrl != null) {
      this.apiSelectValues = await configurationService.getFormData(this.apiUrl, null)
    }
  },
  async mounted() {
    if (this.defaultValue) {
      this.filters = this.defaultValue
    }
    this.storeData()
    this.setCountryJson(this.$i18n.locale)
    await storeService.getStores()
  },
  methods: {
    async setCountryJson(lang) {
      this.countries = countriesJson[lang.replace('-', '_')]
    },
    // label: first column, value: second column, extra:  extra data
    formatDataSelectFullScreen(label, value, extra = null) {
      return { label, value, extra }
    },
    storeData() {
      if (this.name === 'defect_positions') {
        this.$emit('addData', {
          value: this.filters.length > 0 ? this.formatDataDefect(this.filters) : [null],
          name: this.name
        })
      } else {
        this.$emit('addData', { value: this.filters, name: this.name })
      }
    },
    formatDataDefect(data) {
      return [{ label: data[0].label, id: data[0].value, price: data[0].extra.price }]
    },
    getDisplaySegment(value) {
      return this.exploreData(this.countries, value)
    },
    exploreData(array, value) {
      for (const iterator of array) {
        if (iterator.code === value) {
          return `${iterator.name} (${iterator.code})`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.full-screen {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 10px 0;

  .label {
    padding-left: 12px;
    color: #777;
    font-size: 0.75rem !important;
    text-align: left;
  }

  .main-form {
    display: flex;
    padding-left: 12px;

    .segments {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;

      .segment {
        font-size: 0.8rem !important;

        >span {
          margin-right: 5px;
        }
      }
    }
  }

  .delete-values {
    padding: 5px;
    place-self: center center;

    >img {
      height: 1rem;
    }
  }
}
</style>
